<template>
  <el-table-column
    prop="description"
    :sortable="false"
    label="Leírás"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.description }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'description',
  };
</script>
